module.exports = __webpack_public_path__ + "img/spiral-details3.ae7be6d1.png";